/**
 * The pharmacy shell's status bar (design/ux/01_foundations.md §3.13, §6.1;
 * OP-F-20; WP-18): 28 px, 13 px, at the bottom of the shell, hidden below
 * 1024 px. Connection / synchronisation from the offline engine, the
 * pharmacy, the user and role, the date — the ui/StatusBar shell of WP-16.
 */
import * as React from "react";
import { StatusBar } from "@/components/ui/ActionBar";
import { fmtDate, fmtTime, LOCALE_LABELS } from "@/config/locale.config.js";
import { useAuthStore } from "@/stores/authStore.js";
import { useOfflineStore } from "@/offline/offlineStore.js";
import { msUntilMidnight, statusBarItems } from "@/lib/shell-status.js";

function useToday() {
  const [today, setToday] = React.useState(() => new Date());
  React.useEffect(() => {
    const t = window.setTimeout(() => setToday(new Date()), msUntilMidnight(today));
    return () => window.clearTimeout(t);
  }, [today]);
  return today;
}

export const ShellStatusBar: React.FC = () => {
  const user = useAuthStore((s: any) => s.user);
  const status = useOfflineStore((s: any) => s.status);
  const pending = useOfflineStore((s: any) => s.pending);
  const lastSyncAt = useOfflineStore((s: any) => s.lastSyncAt);
  const enrolled = useOfflineStore((s: any) => Boolean(s.serverEnabled && s.device));
  const today = useToday();
  const items = statusBarItems({
    status,
    pending,
    lastSyncAt,
    enrolled,
    pharmacyName: user?.pharmacie?.nom ?? null,
    userName: [user?.prenom, user?.nom].filter(Boolean).join(" "),
    roleLabel: user?.role ? ((LOCALE_LABELS as Record<string, string>)[user.role] ?? user.role) : "",
    dateText: fmtDate(today),
    timeText: (iso: string) => fmtTime(iso),
  });
  return (
    <footer className="pk-shell-status" style={{ gridArea: "status" }} aria-label="Barre d'état">
      <StatusBar items={items as any} />
    </footer>
  );
};

export default ShellStatusBar;
